// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"EK-z","smallCardRow":"FK-z","largeCardRow":"GK-z","productSearchRow":"HK-z","curatedRow":"IK-z"};